import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
 * 查询联动视频配置分页
 */
export function getLinkagePage(params) {
    return request({
        url: envInfo.bgApp.basePath + '/linkage/page',
        method: 'get',
        params
    })
}

/**
 * 查询联动视频配置
 */
export function getLinkageBySourceCode(params) {
    return request({
        url: envInfo.bgApp.basePath + '/linkage/find/'+params.sourceCode,
        method: 'get',
    })
}

/**
 * 创建联动视频配置
 * @param params
 */
export function createLinkage(params) {
    return request({
        url: envInfo.bgApp.basePath + '/linkage/create',
        method: 'post',
        data : params
    })
}

/**
 * 修改联动视频配置
 * @param params
 */
export function updateLinkage(params) {
    return request({
        url: envInfo.bgApp.basePath + '/linkage/update',
        method: 'post',
        data : params
    })
}

/**
 * 删除联动视频配置
 * @param params
 */
export function deleteLinkage(params) {
    return request({
        url: envInfo.bgApp.basePath + '/linkage/delete/'+params.linkageId,
        method: 'delete',
    })
}
